import { DocumentFormField } from '~/core/shared/types';

export const fieldMatchesSearch = (
  field: DocumentFormField,
  searchTerm: string,
): boolean => {
  const term = searchTerm.toLowerCase();

  return (
    field.name.toLowerCase().includes(term) ||
    field.label.toLowerCase().includes(term) ||
    (field.value != null && `${field.value}`.toLowerCase().includes(term))
  );
};
